import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import Icon from '../../../../../components/Elements/Icon';

export const NoDataMessage = () => {
  const theme = useTheme();
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 0',
        height: '100%',
      }}
    >
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(4),
          borderRadius: theme.spacing(1),
          backgroundColor: theme.palette.grey[50],
          maxHeight: '400px',
          maxWidth: '400px',
        }}
      >
        <Icon 
          name="NoDataFound" 
          height="100px" 
          width="100px" 
          style={{ 
            marginBottom: theme.spacing(2),
            opacity: 0.8,
          }}
        />
        <Typography 
          variant="h6" 
          color="textSecondary"
          align="center"
          sx={{ 
            fontWeight: 500,
            marginBottom: theme.spacing(1)
          }}
        >
          No data found
        </Typography>
        <Typography 
          variant="body2" 
          color="textSecondary"
          align="center"
        >
          Try adjusting your filters or selecting a different time period.
        </Typography>
      </Box>
    </Box>
  );
}; 